import styled from 'styled-components';
import { Icon } from 'antd';

export const GarageName = styled.div`
  font-weight: bold;
  font-size: 13px;
  position: relative;
`;

export const CoverageIcon = styled(Icon)`
  cursor: pointer;
  font-size: 23px;
  padding-left: 10px;
  &.in-coverage {
    color: #52c41b;
  }
  &.out-of-coverage {
    color: orange;
  }
`;

export const CantDoWorkTag = styled.div`
  color: #bd4f2b;
  border: 1px solid #bd4f2b;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 10px;
  margin-top: 2px;
`;

export const ChangeCndWrapper = styled.div`
  background: #fafafa;
  padding: 15px 15px;
  .ant-radio {
    margin-left: 10px;
    margin-right: 5px;
    font-weight: bold;
  }
`;

export const CnDChangeWarning = styled.div`
  display: flex;
  border-radius: 4px;
  background-color: #ffecec;
  padding: 15px 15px 5px 15px;
  margin: 10px;
  max-width: fit-content;
  > .text {
    margin-left: 5px;
    > span:nth-child(1) {
      color: #d64040;
      > span {
        color: white;
        background-color: #d64040;
        padding: 5px 7px;
        border-radius: 4px;
      }
    }
    span.reminder {
      font-size: 12px;
      line-height: 36px;
    }
  }
`;
